import {
  fetchWrapper,
  handleResponse,
  hcUrlV3,
  buildOpts,
  formatBody,
} from 'services/RequestService/helpers';

const createExperimentAssignment = async ({ params }) => {
  const response = await fetchWrapper(
    hcUrlV3('/experiment_assignments'),
    buildOpts({
      method: 'POST',
      body: formatBody({
        experiment: {
          experimentName: params.name,
        },
      }),
    })
  );
  return handleResponse(response);
};

const getExperimentAssignment = async ({ params }) => {
  const response = await fetchWrapper(hcUrlV3(`/experiment_assignments/${params.name}`));
  return handleResponse(response);
};

const getExperiment = async ({ params }) => {
  const response = await fetchWrapper(hcUrlV3(`/experiments/${params.name}`));
  return handleResponse(response);
};

export { getExperimentAssignment, createExperimentAssignment, getExperiment };
